import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityUsersDataProvider } from './dataProvider';

// 注册 activity/users 模块的数据提供者
export function initActivityUsersDataProvider() {
  registerModuleDataProvider('activity-users', activityUsersDataProvider);
}

// 自动初始化
initActivityUsersDataProvider();
